function handleAnnouncementBarClose(button) {
  const bar = button.closest('.announcement-bar-section');
  const barHeight = bar.offsetHeight;

  sessionStorage.setItem('announcementBarClosed', 'true');

  bar.style.transition = 'transform 0.3s ease';
  bar.style.transform = `translateY(-${barHeight}px)`;
  document.body.style.transition = 'margin-top 0.3s ease';
  document.body.style.marginTop = `-${barHeight}px`;

  setTimeout(() => {
    document.body.style.transition = '';
    document.body.style.marginTop = '';
    bar.remove();
  }, 300);
}

document.addEventListener('DOMContentLoaded', () => {
  const closeButton = document.querySelector('.announcement-close-button');
  if (closeButton) {
    closeButton.addEventListener('click', () => handleAnnouncementBarClose(closeButton));
  }
});

if (sessionStorage.getItem('announcementBarClosed') === 'true') {
  document.documentElement.classList.add('announcement-bar-closed');
}
